import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import Leden from './views/Leden.vue';
import Besturen from './views/Besturen.vue';
import Gallerij from './views/Gallery/Gallery.vue';
import Album from './views/Gallery/Albums/Show.vue';
import i18n from './i18n';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: {
        titleKey: 'metadata.home_title',
      },
    },
    {
      path: '/Leden',
      name: 'Leden',
      component: Leden,
      meta: {
        titleKey: 'metadata.members_title',
      },
    },
    {
      path: '/Bestuur',
      name: 'Bestuur',
      component: Besturen,
      meta: {
        titleKey: 'metadata.board_title',
      },
    },
    {
      path: '/Gallerij',
      name: 'Gallerij',
      component: Gallerij,
      meta: {
        titleKey: 'metadata.gallery_title',
      },
    },
    {
      path: '/Gallerij/Album/:albumid',
      name: 'Album',
      component: Album,
      props: true,
      meta: {
        titleKey: 'metadata.album_title',
      },
    },
    // {
    //   path: '/about',
    //   name: 'about',
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () => import(/* webpackChunkName: "about" */ './views/About.vue'),
    // },
  ],
});

router.afterEach((to) => {
  document.title = i18n.t(to.meta.titleKey || 'metadata.site_name');
});

export default router;
